type Environment = "development" | "staging" | "test" | "production";
export interface IEnvironmentConfig {
  protocol: "http" | "https";
  host: string;
}

const urlConfigs: Record<Environment, IEnvironmentConfig> = {
  development: {
    protocol: "https",
    host: "localhost:8080",
  },
  staging: {
    protocol: "https",
    host: "app.staging.getclockwise.com",
  },
  test: {
    protocol: "https",
    host: "app.getclockwise.com",
  },
  production: {
    protocol: "https",
    host: "app.getclockwise.com",
  },
};

const env = (process.env.NODE_ENV as Environment | undefined) ?? "development";
const c = urlConfigs[env];
const socketProtocol = c.protocol === "https" ? "wss" : "ws";

export const GRAPHQL_URL = `${c.protocol}://${c.host}/graphql`;
export const GRAPHQL_BATCH_URL = `${GRAPHQL_URL}/batch`;
export const SUBSCRIPTION_URL = `${socketProtocol}://${c.host}/subscription`;
